// Copyright (c) 2018 Deere & Company

import InformationRequestForm, {getDefaultState as getInformationRequestFormDefaultState} from './information-request-form';
import PartRequestForm, {getDefaultState as getPartRequestFormDefaultState} from './part-request-form';
import PartReturn, {getDefaultState as getDefaultPartReturnState} from '@deere/cps-it.warranty-model-factory/lib/part-return';
import PictureRequestForm, {getDefaultState as getPictureRequestFormDefaultState} from './picture-request-form';
import t from 'tcomb';

const State = t.struct({
    busyCounter: t.Number,
    informationRequestForm: InformationRequestForm,
    isFormDirty: t.Boolean,
    partRequestForm: PartRequestForm,
    partReturn: PartReturn,
    pictureRequestForm: PictureRequestForm
}, 'State');

export const getDefaultState = () => new State({
    busyCounter: 0,
    informationRequestForm: getInformationRequestFormDefaultState(),
    isFormDirty: false,
    partRequestForm: getPartRequestFormDefaultState(),
    partReturn: getDefaultPartReturnState(),
    pictureRequestForm: getPictureRequestFormDefaultState()
});

export default State;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/state/index.js